export function commentFactory($resource, MyConstant) {
    "ngInject"

    return $resource('', {}, {
        insert: {
            url: `${MyConstant.ApiUrl}Comment/InsertComment`,
            method: 'POST',
        },
        query: {
            url: `${MyConstant.ApiUrl}Comment/GetAllComment?productId=:productId&rowPage=100&pageNumber=1`,
            isArray: false,
            method: 'GET'
        }
    })
}



// WEBPACK FOOTER //
// ./src/factories/comment/comment.ts